import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import toast from 'react-hot-toast';

import { ContainerButtonPlay } from '../../Utils/Button';
import { IUserFromStorage } from '../../Interfaces/IUser';
import { getMiniCurso } from '../../Services/MiniCurso';
import { IMiniCursoResponse } from '../../Interfaces/IMiniCurso';
import Loading from '../../Utils/Loading';
import VideoPlayer from '../../Components/VideoPlayer/VideoPlayer';
import MiniCursoVeroPC from '../../Components/MiniCurso/MiniCursoVeroPC';

import { grayPlayButton } from '../../Shared/Images';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import atrasIcon from '../../Shared/Images/atras-icon.png';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ScrollToBottomFab from '../../Components/FAB/ScrollToBottomFab';


interface Props {
  productId: number;
}

const MiniCursoVero = ({ productId }: Props) => {

  const [mostrarVideo, setMostrarVideo] = useState<boolean>(false);
  const [data, setData] = useState<IMiniCursoResponse[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [dataMiniCurso, setDataMiniCurso] = useState<IMiniCursoResponse>();
  const [currentPosition, setCurrentPosition] = useState<number>(0);

  const user : IUserFromStorage = JSON.parse(localStorage.getItem("user")) || '';
  const matches = useMediaQuery('(max-width: 650px)');
  const navigate = useNavigate();
  
  useEffect(() => {
    getMiniCurso({
      UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
      TipoPagoID: productId ?? 24,
      Agrupado: false
    })
      .then(res => {
        if(res.data.data.length > 0) {
          setData(res.data.data);
        }
      })
      .catch(err => {
        toast.error(`Algo salió mal, inténtelo de nuevo más tarde ${err}`);
      })
      .finally(() => {
        setIsLoading(false);
      })

  }, [])

  useEffect(() => {
    if (data && data.length > 0) {
      setDataMiniCurso({
        descripcion:      data[currentPosition].descripcion,
        miniCursoVideoID: data[currentPosition].miniCursoVideoID,
        titulo:           data[currentPosition].titulo,
        urlVimeoHLS:      data[currentPosition].urlVimeoHLS,
        portada:          data[currentPosition].portada,
        orden:            data[currentPosition].orden,
      });
    }
  }, [data, currentPosition])

  function retrocederVideo () {
    if(currentPosition !== 0) {
      if(data[currentPosition - 1]) {
        setCurrentPosition( c => c - 1 );
      }
    }
  }

  function avanzarVideo () {
    if(currentPosition + 1 !== data.length) {
      if(data[currentPosition + 1]) {
        setCurrentPosition( c => c + 1 );
      }
    } else {
      setMostrarVideo(false);
    }
  }

  return (
    <div className="w-full">
      {isLoading ? (
        <div
          className="flex align-items-center justify-content-center"
          style={{ height: '70vh' }}
        >
          <div>
            <Loading></Loading>
            {/* <Container maxWidth="xs">
              Espera un momento por favor, mientras carga el programa
            </Container> */}
          </div>
        </div>
      ) : (
        <>
          {data && data.length > 0 ? (
            !matches ? (
              <MiniCursoVeroPC 
                data={data}
              />
            ) : (
              <div
                style={{
                  alignItems: 'center',
                  minHeight: '',
                  position: 'relative',
                  padding: '1rem 1.2rem',
                  left: '-8px',
                }}
                className='w-full'
              >
                <div>
                  <div className="flex items-center" style={{ gap: '1rem' }}>
                    <img
                      onClick={() => navigate('/')}
                      src={atrasIcon}
                      style={{ width: '35px', height: '25px' }}
                    />
                    <p className="title"> Autodisciplina Fit </p>
                  </div>

                  <div className="flex justify-start text-left w-full">
                    <p
                      className="m-0 title mt-2 text-[1rem]"
                      style={{ color: '#5F5F5F', fontWeight: 'semibold' }}
                    >
                      <span className='font-bold text-[1.10rem]'>{currentPosition + 1 }:</span> {dataMiniCurso?.titulo ? dataMiniCurso?.titulo : ''}
                    </p>
                  </div>

                  <div className="flex flex-col gap-4 m-auto">
                    {data && data.length > 0 && data[0].urlVimeoHLS && dataMiniCurso && (
                      <>
                        <div className="mt-4">
                          {!mostrarVideo ? (
                            <div className="relative" style={{ height: '100%' }}>
                              <ContainerButtonPlay
                                onClick={() => {
                                  setMostrarVideo(true);
                                }}
                              >
                                <img src={ grayPlayButton } alt="" width={80} />
                              </ContainerButtonPlay>

                              <img
                                width={'100%'}
                                height={'100%'}
                                src={ dataMiniCurso.portada }
                                alt="portada"
                              />
                            </div>
                          ) : (
                            <VideoPlayer
                              url={ dataMiniCurso.urlVimeoHLS }
                              onEnded={ avanzarVideo }
                            />
                          )}
                        </div>
                        <div className="flex flex-col justify-center items-center">

                          <p style={{ textAlign: 'start' }} className="cardText">
                            {dataMiniCurso?.descripcion}
                          </p>
                          <button 
                            className='bg-red-500 hover:bg-[#e95a5a] p-2 text-white rounded-md'
                            style={{boxShadow: `
                              inset 0 4px 6px rgba(255, 255, 255, 0.3),
                              inset 0 -4px 6px rgba(0, 0, 0, 0.2),
                              0 4px 10px rgba(0, 0, 0, 0.25)
                            `}}
                          >
                            <a 
                              href={`https://bonostr4iner.s3.us-east-2.amazonaws.com/workbook_${dataMiniCurso.orden}.pdf`}
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={{ textDecoration: 'none', color: 'white', fontSize: '1rem' }}
                            >
                              Descarga tu Workbook <TouchAppIcon />
                            </a>
                          </button>

                        </div>

                        <div
                          className="flex items-center justify-center gap-4"
                        >
                          <button
                            className="font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-[#FDB600] px-[30px] flex items-center gap-1 opacity-95 disabled:opacity-65 hover:opacity-100 disabled:cursor-default"
                            disabled={ currentPosition === 0 ? true : false }
                            onClick={retrocederVideo}
                          >
                            <ArrowBackIosIcon sx={{ fontSize: '10px' }} /> Anterior 
                          </button>

                          <button
                            className={`font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-[#FDB600] px-[30px] flex items-center gap-1 opacity-95 disabled:opacity-65 hover:opacity-100 disabled:cursor-default`}
                            disabled={currentPosition + 1 === data.length ? true : false}
                            onClick={avanzarVideo}
                          >
                            Siguiente <ArrowForwardIosIcon sx={{ fontSize: '10px' }} />
                          </button>
                        </div>
                      </>
                    )}
                  </div>     

                  {/* bottom float button */}
                  {/* <ScrollToBottomFab 
                    size='small'
                  /> */}
                </div>
              </div>
            )
          ) : (
            <div className="mx-1 my-5">Proximamente</div>
          )}
        </>
      )}
    </div>
  );
};

export default MiniCursoVero;